// extracted by mini-css-extract-plugin
export var animationContainer = "_i1-0";
export var footer = "_i1-1";
export var gray = "_i1-2";
export var lineItem = "_i1-3";
export var lineItemImage = "_i1-4";
export var lineItemInfo = "_i1-5";
export var lineItemText = "_i1-6";
export var lineItems = "_i1-7";
export var modalContent = "_i1-8";
export var options = "_i1-9";
export var orderName = "_i1-a";
export var refundAmount = "_i1-b";